<template>
  <div class="login d-flex align-items-center">
    <main class="form-signin">
        <form @submit.prevent="submit" novalidate>
          <router-link to="/inicio">
          <img class="mb-4  mx-auto d-block" src="@/assets/img/logo-vertical.png" alt="" width="250">
        </router-link>
          <div class="form-floating">
            <input type="email" class="form-control" id="floatingInput" placeholder="name@example.com" v-model="loginForm.Correo">
            <label for="floatingInput">Email address</label>
          </div>
          <!--<div class="form-floating">
            <input type="password" class="form-control" id="floatingPassword" placeholder="Password" v-model="loginForm.Clave" required>
            <label for="floatingPassword">Password</label>
          </div>-->

          <div class="form-floating input-group">
            <input type="password" class="form-control" id="floatingPassword" placeholder="Password" v-model="loginForm.Clave" required>
            <label for="floatingPassword">Password</label>
            <div class="input-group-append">
                <button id="show_password" class="btn btn-sm btn-login" type="button" @click="mostrarPassword"> <span class="fa fa-eye-slash icon"></span> </button>
            </div>
          </div>
      
          <div class="checkbox mb-3">
            
            <router-link to="/auth-recuperar-contrasena">
            <a class="float-end">Olvidé contraseña</a>
            </router-link>
          </div>
          <button class="w-100 btn btn-lg btn btn-registro" type="submit" :disabled="deshabilitado">Iniciar sesión</button>

        <p class="m-t text-center">¿ No tienes una cuenta ?
        <router-link to="/auth-registro"> Crear cuenta </router-link> </p>
        
        </form>
      </main>
    </div>     
</template>

<script>

import helpers from '@/services/helpers'
import auth from '@/services/auth'

export default {
  name: "Login",
  data() {
    return {
      loginForm: {
        Correo: "",
        Clave: "",
      },
      deshabilitado: true,
    };
  },

  mounted() {
    helpers.habilitarBoton(this);
  },
  methods: {
    async submit(e) {
      
      let _this = this;
      //helpers.deshabilitarBoton(this);
     
      if (
        _this.loginForm.Correo.length < 5 ||
        _this.loginForm.Clave.length < 5
      ) {
        toastr["error"]("Ingrese un usuario y contraseña válido");
        return;
      }
      
      if (await auth.login(this)){
        //console.log("INICIO CORRECTO");
      }
      else{
        //console.log("ERROR AL INICIAR SESIÓN");
      }
      helpers.habilitarBoton(this, 4);
    },
    mostrarPassword(){
      var cambio = document.getElementById("floatingPassword");
		if(cambio.type == "password"){
			cambio.type = "text";
			$('.icon').removeClass('fa fa-eye-slash').addClass('fa fa-eye');
		}else{
			cambio.type = "password";
			$('.icon').removeClass('fa fa-eye').addClass('fa fa-eye-slash');
		}
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/auth/Login.vue